<script setup lang="ts">
import __MACROS_useVModel from "/vue-macros/define-models/use-vmodel";
defineProps({
  id: null,
  label: null,
  icon: null,
  loading: { type: Boolean },
  disabled: { type: Boolean },
  tooltip: null,
  customclass: null,
  position: null
});
const _defineModels_emit = defineEmits(["click", "update:id", "update:label", "update:icon", "update:loading", "update:disabled", "update:tooltip", "update:customclass", "update:position"])

__MACROS_useVModel("id", "label", "icon", "loading", "disabled", "tooltip", "customclass", "position")

function handleChange(event: Event) {
  const { target } = event
  if (target)
    return (target as HTMLInputElement).value
  return null
}
</script>

<template>
  <template v-if="tooltip">
    <button
      :id="id"
      class="self-center px-5 py-2.5"
      :class="[disabled ? 'sb-button-disabled' : 'sb-button', customclass]"
      :disabled="disabled"
      :data-tooltip-target="tooltip ? `tooltip-${id}` : false"
      data-tooltip-style="light"
      @click.exact.stop.prevent="$emit('click', handleChange($event))"
    >
      <div v-if="loading" i-mdi-loading aria-hidden="true" role="status" class="mx-2 inline h-5 w-5 shrink-0 animate-spin text-blue-700 dark:text-white" />
      <template v-else>
        <div v-if="icon" class="h-5 w-5 shrink-0" :class="label ? 'mr-2' : ''" :i="icon" />
        <span v-if="label" class="shrink-0">{{ label }}</span>
      </template>
      <div v-if="tooltip" :id="`tooltip-${id}`" role="tooltip" class="sb-tooltip" :class="position">
        {{ tooltip }}
      </div>
    </button>
  </template>

  <template v-else>
    <button
      :id="id"
      class="flex shrink-0 self-center px-5 py-2.5"
      :class="[disabled ? 'sb-button-disabled' : 'sb-button', customclass]"
      :disabled="disabled"
      @click.exact.stop.prevent="$emit('click', handleChange($event))"
    >
      <div v-if="loading" i-mdi-loading aria-hidden="true" role="status" class="mx-2 inline h-5 w-5 shrink-0 animate-spin text-blue-700 dark:text-white" />
      <template v-else>
        <div v-if="icon" class="h-5 w-5 shrink-0" :class="label ? 'mr-2' : ''" :i="icon" />
        <span v-if="label" class="shrink-0">{{ label }}</span>
      </template>
    </button>
  </template>
</template>
